/** The top-level compomemt for entire app. It:
 * renders headers according to screen - mobile and desktop
 * renders footer
 * uses dayjs library for calculating notification count (comparing with notification state)
 * 
*/

//libraries
import { useMediaQuery } from "react-responsive";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

//redux
import { useSelector } from "react-redux";

//components
import HeaderMain from "./header/header";
import Footer from "./footer/footer";
import HeaderDesktop from "./header/headerDesktop";
const FooterAndHeader = () => {

    const isDesktop = useMediaQuery({minWidth: 821});

    // getting notifications count
    dayjs.extend(isSameOrBefore);

    const unreadCount = useSelector((state) => {
        const today = dayjs().startOf('day');

        return state.notifications?.list?.filter(n =>
            !n.read &&
            dayjs(n.notificationDate).isValid() &&
            dayjs(n.notificationDate).isSameOrBefore(today, 'day')
        ).length || 0;        
    });    

    return(
        <>
            {!isDesktop && <HeaderMain unreadCount={unreadCount} />}
            {isDesktop && <HeaderDesktop unreadCount={unreadCount} />}
            <Footer></Footer>
        </>
    )
};

export default FooterAndHeader;